/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Bio_BeInputs */

const en_resume_bio_be = /** @type {(inputs: Resume_Bio_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back-end Engineer building robust, scalable server-side systems and APIs with clean architecture.`)
};

const ar_resume_bio_be = /** @type {(inputs: Resume_Bio_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مهندس واجهات خلفية يبني أنظمة خادم قوية وقابلة للتوسع وواجهات برمجية بمعمارية نظيفة.`)
};

const bn_resume_bio_be = /** @type {(inputs: Resume_Bio_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ব্যাক-এন্ড ইঞ্জিনিয়ার হিসেবে পরিষ্কার আর্কিটেকচারে মজবুত ও স্কেল করা যায় এমন সার্ভার-সাইড সিস্টেম এবং API তৈরি করি।`)
};

const de_resume_bio_be = /** @type {(inputs: Resume_Bio_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back-End-Ingenieur, der robuste, skalierbare serverseitige Systeme und APIs mit sauberer Architektur erstellt.`)
};

const es_resume_bio_be = /** @type {(inputs: Resume_Bio_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingeniero de back-end que construye API y sistemas del lado del servidor robustos y escalables con una arquitectura limpia.`)
};

const fr_resume_bio_be = /** @type {(inputs: Resume_Bio_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingénieur back-end créant des systèmes et des API côté serveur robustes et évolutifs avec une architecture propre.`)
};

const pt_resume_bio_be = /** @type {(inputs: Resume_Bio_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engenheiro de back-end construindo sistemas e APIs robustos e escaláveis ​​do lado do servidor com arquitetura limpa.`)
};

const zh_resume_bio_be = /** @type {(inputs: Resume_Bio_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`后端工程师使用简洁的架构构建强大、可扩展的服务器端系统和 API。`)
};

const tr_resume_bio_be = /** @type {(inputs: Resume_Bio_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temiz mimariyle sağlam, ölçeklenebilir sunucu tarafı sistemler ve API'ler oluşturan Backend Mühendisi.`)
};

const ru_resume_bio_be = /** @type {(inputs: Resume_Bio_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Серверный инженер, создающий надежные, масштабируемые серверные системы и API с чистой архитектурой.`)
};

const pl_resume_bio_be = /** @type {(inputs: Resume_Bio_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inżynier back-endu budujący solidne, skalowalne systemy i interfejsy API po stronie serwera o czystej architekturze.`)
};

/**
* | output |
* | --- |
* | "Back-end Engineer building robust, scalable server-side systems and APIs with clean architecture." |
*
* @param {Resume_Bio_BeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_bio_be = /** @type {((inputs?: Resume_Bio_BeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Bio_BeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_bio_be(inputs)
	if (locale === "bn") return bn_resume_bio_be(inputs)
	if (locale === "de") return de_resume_bio_be(inputs)
	if (locale === "es") return es_resume_bio_be(inputs)
	if (locale === "fr") return fr_resume_bio_be(inputs)
	if (locale === "pt") return pt_resume_bio_be(inputs)
	if (locale === "zh") return zh_resume_bio_be(inputs)
	if (locale === "tr") return tr_resume_bio_be(inputs)
	if (locale === "ru") return ru_resume_bio_be(inputs)
	if (locale === "pl") return pl_resume_bio_be(inputs)
	return en_resume_bio_be(inputs)
});